import React from "react";

export const CloseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="#666666" viewBox="0 0 24 24" focusable="false" width={24} height={24}><path d="M 19 6.41 L 17.59 5 L 12 10.59 L 6.41 5 L 5 6.41 L 10.59 12 L 5 17.59 L 6.41 19 L 12 13.41 L 17.59 19 L 19 17.59 L 13.41 12 Z" /><path fill="none" d="M 0 0 h 24 v 24 H 0 Z" /></svg>
  );
};